import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Carousel from 'react-bootstrap/Carousel';
import img1 from '../assests/gst_image1.jpg';
import img2 from '../assests/gst_image2.webp';
import img3 from '../assests/gst_image3.jpg';
import img4 from '../assests/gst_image4.webp';
import dq1 from '../assests/double-quotes-l.svg';
import dq2 from '../assests/double-quotes-lI.svg';
import config from '../config';

function ControlledCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel className="carList" activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
        <img
          className="CarItem d-block w-100"
          src={img1}
          alt="First slide"
        />
        <Carousel.Caption>
          { /*<h3>First slide label</h3>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="CarItem d-block w-100"
          src={img2}
          alt="First slide"
        />
        <Carousel.Caption>
          { /*<h3>Second slide label</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="CarItem d-block w-100"
          src={img3}
          alt="First slide"
        />
        <Carousel.Caption>
          { /*<h3>Third slide label</h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur. 
          </p> */}
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="CarItem d-block w-100"
          src={img4}
          alt="First slide"
        />
        <Carousel.Caption>
          { /*<h3>Fourth slide label</h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
          </p> */}
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

const GetContent = ({ lang, setStateLang, curPage, setCurPage }) => {

    function SetExplaination(e){
        e.preventDefault();
        var el = e.target;
        //console.log(lang)
        document.getElementById("expTitle").innerHTML=config.pg_content.home[el.id]["title"][lang]
        document.getElementById("expDesc").innerHTML=config.pg_content.home[el.id]["desc"][lang]
        document.getElementById("expTitle").focus();
    }

    return (
        <div className='section p-3'>
            <div className="row">
                <div className="col-md-5 shadow py-5 rounded hide-on-mobile">
                    <ControlledCarousel />
                </div>
                <div className="col-md-7 border-start">
                    <h3 className="p-4" >
                      <span className="dcont" id="con1">{config.pg_content.home.con1[config.lang]}</span> &nbsp; &nbsp;
                      <span className="dcont sub-title" id="con2">{config.pg_content.home.con2[config.lang]}</span>
                    </h3>
                    <div className="container">
                      <div className="row">
                          <div className="col-md-6 shadow-sm p-2 rounded">
                            <div className="service-title p-2 rounded dcont" id="con3">{config.pg_content.home.con3[config.lang]}</div>
                            <ul className="service-li" >
                                <li><Link onClick={SetExplaination} className="dcont" id="con7" name="title" >{config.pg_content.home.con7.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con8" name="title" >{config.pg_content.home.con8.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con9" name="title" >{config.pg_content.home.con9.title[config.lang]}</Link></li>
                            </ul>
                          </div>
                          <div className="col-md-6 shadow-sm p-2 rounded">
                            <div className="service-title p-2 rounded dcont" id="con4">{config.pg_content.home.con4[config.lang]}</div>
                            <ul className="service-li" >
                                <li><Link onClick={SetExplaination} className="dcont" id="con10" name="title" >{config.pg_content.home.con10.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con11" name="title" >{config.pg_content.home.con11.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con12" name="title" >{config.pg_content.home.con12.title[config.lang]}</Link></li>
                            </ul>
                          </div>
                          <div className="col-md-6 shadow-sm p-2 rounded">
                            <div className="service-title p-2 rounded dcont" id="con5">{config.pg_content.home.con5[config.lang]}</div>
                            <ul className="service-li" >
                                <li><Link onClick={SetExplaination} className="dcont" id="con13" name="title" >{config.pg_content.home.con13.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con14" name="title" >{config.pg_content.home.con14.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con15" name="title" >{config.pg_content.home.con15.title[config.lang]}</Link></li>
                            </ul>
                          </div>
                          <div className="col-md-6 shadow-sm p-2 rounded">
                            <div className="service-title p-2 rounded dcont" id="con6">{config.pg_content.home.con6[config.lang]}</div>
                            <ul className="service-li" >
                                <li><Link onClick={SetExplaination} className="dcont" id="con16" name="title" >{config.pg_content.home.con16.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con17" name="title" >{config.pg_content.home.con17.title[config.lang]}</Link></li>
                                <li><Link onClick={SetExplaination} className="dcont" id="con18" name="title" >{config.pg_content.home.con18.title[config.lang]}</Link></li>
                            </ul>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-2 dq"><img className="dql" src={dq1} alt="" /></div>
              <div className="col-md-8 p-4">
                <div className="explain-title p-2">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#" id="expTitle">{config.pg_content.home.con7.title[config.lang]}</a>
                </div>
                <div className="explain-desc" id="expDesc" dangerouslySetInnerHTML={{ __html: config.pg_content.home.con7.desc[config.lang] }}></div>
              </div>
              <div className="col-md-2 dq"><img className="dqr" src={dq2} alt="" /></div>
            </div>
        </div>
    );
}

export default GetContent;